module.exports = __webpack_public_path__ + "static/img/goods-800.8c7d286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/pop/goods-800.png
// module id = yfQ4
// module chunks = 2